module.exports = __webpack_public_path__ + "static/media/Triangle2.2ce14c32.jpg";